"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_2 = require("react-redux");
var store_2 = require("../../store");
var semantic_ui_react_7 = require("semantic-ui-react");
var logo = require("../../images/icon_75.png");
var gatsby_utils_2 = require("../../gatsby-utils");
exports.HeaderMenu = function (_ref) {
    var items = _ref.items,
        pathname = _ref.pathname,
        Link = _ref.Link,
        inverted = _ref.inverted,
        dispatch = _ref.dispatch;
    return React.createElement(semantic_ui_react_7.Container, null, React.createElement(semantic_ui_react_7.Menu, { size: "large", pointing: true, secondary: true, inverted: inverted }, React.createElement(semantic_ui_react_7.Menu.Item, { as: "a", className: "mobile only", icon: "sidebar", onClick: function onClick() {
            return dispatch(store_2.toggleSidebar());
        } }), React.createElement(semantic_ui_react_7.Menu.Item, { as: Link, to: "/", name: "Gradus Reason Home", className: "mobile hidden" }, React.createElement("img", { src: logo, alt: "Gradus Reason" })), items.map(function (item) {
        var unprefixedPathname = gatsby_utils_2.withoutPrefix(pathname);
        var active = item.exact ? unprefixedPathname === item.path : unprefixedPathname.startsWith(item.path);
        return React.createElement(semantic_ui_react_7.Menu.Item, { as: Link, className: "mobile hidden", name: item.name, to: item.path, key: item.path, active: active });
    }), React.createElement(semantic_ui_react_7.Menu.Item, { href: "https://github.com/codekiln/gradus-reason", target: "_blank" }, React.createElement(semantic_ui_react_7.Icon, { name: "github", alt: "Gradus Reason" }))));
};
exports.default = react_redux_2.connect()(exports.HeaderMenu);


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/home/travis/build/codekiln/gradus-reason/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/components/HeaderMenu/HeaderMenu.tsx